import { Formik } from 'formik';
import React from 'react';
import { Dashboard, PageLayout } from '@components';
import { LeavingGuard } from '@components/utils/LeavingGuard';
import { BackButton, HeadContent, Loading, SaveShortcutListener } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { ConfirmBar } from '../../../../modules/ConfirmBar';
import { GiftCardStatusTag } from '../../components/GiftCardStatusTag/GiftCardStatusTag';
import { validationSchema } from './consts';
import { useGiftCard } from './hooks/useGiftCard';
import { GiftCardDetails } from './modules/GiftCardDetails/GiftCardDetails';
import { GiftCardExpirationDate } from './modules/GiftCardExpirationDate/GiftCardExpirationDate';
import { GiftCardShareBanner } from './modules/GiftCardShareBanner/GiftCardShareBanner';
import { GiftCardSummary } from './modules/GiftCardSummary';
import { getGiftCardTitle } from './utils/getGiftCardTitle';
import { isGiftCardGroup } from './utils/isGiftCardGroup';
export const GiftCard = () => {
    const { giftCard, initialValues, isCreating, isSubmitting, isFetching, onSubmit } = useGiftCard();
    const isFormLoading = isSubmitting || isFetching;
    const getPageTitle = () => {
        if (isCreating) {
            return 'Create gift card';
        }
        return giftCard ? getGiftCardTitle(giftCard) : '';
    };
    const leftContent = (React.createElement(React.Fragment, null,
        React.createElement(GiftCardDetails, { disabled: !isCreating, giftCards: giftCard && isGiftCardGroup(giftCard) ? giftCard.giftCards : [] }),
        React.createElement(GiftCardExpirationDate, null)));
    const renderStatus = () => {
        if (isCreating || !giftCard) {
            return null;
        }
        return React.createElement(GiftCardStatusTag, { status: giftCard.status, size: "large" });
    };
    return (React.createElement(Formik, { initialValues: initialValues, validationSchema: validationSchema, onSubmit: onSubmit, enableReinitialize: true }, ({ dirty, submitForm }) => (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: getPageTitle() }),
        React.createElement(Loading, { isLoading: isFormLoading },
            React.createElement(PageLayout, { rightContent: React.createElement(GiftCardSummary, { giftCard: giftCard }), leftContent: leftContent },
                React.createElement(Dashboard.ItemViewHeader, { name: getPageTitle(), status: renderStatus(), backButton: React.createElement(BackButton, { label: "Promotions", to: routing.promotions.giftCards.self }) }),
                giftCard && React.createElement(GiftCardShareBanner, { giftCard: giftCard }))),
        React.createElement(SaveShortcutListener, { disabled: !dirty, onSave: submitForm }),
        React.createElement(ConfirmBar, { isOpen: dirty, isLoading: isSubmitting, onConfirm: submitForm }),
        React.createElement(LeavingGuard, { when: dirty })))));
};
